<div class="toast">
    <div class="icon">
        <img src="assets/img/x-danger.png" alt="error">
    </div>
    <span *ngIf="!data?.hasBulkUploadError" class="message text-wrap">{{data?.msg || 'Something went wrong!'}}</span>
    <span *ngIf="data?.hasBulkUploadError" class="message" [innerHTML]="data?.msg"></span>
</div>